/** 404, and the offline page for online-only routes (03 §0.3, §16; AC-PWA-03). */
import { t } from '@tarock/i18n';
import { useLocation } from 'preact-iso';
import { Footer } from './Footer';

const ONLINE_ONLY =
  /^\/(lobby|t|join|login|signup|verify|reset|2fa|welcome|profile|history|replay|leaderboard|admin|legal)(\/|$)/;

/** Whether `path` needs the network (an online-only route shows the offline page while offline). */
function isOnlineOnly(path: string): boolean {
  return ONLINE_ONLY.test(path);
}

/** The fallback route. */
export function NotFound() {
  const { path } = useLocation();
  if (isOnlineOnly(path) && !navigator.onLine) {
    return (
      <main class="page" id="main" data-page="offline">
        <h1>{t('offline.title')}</h1>
        <p>{t('offline.body')}</p>
        <p>
          <a class="btn primary" href="/play/local" data-testid="play-offline">
            {t('offline.playLocal')}
          </a>
        </p>
        <Footer />
      </main>
    );
  }
  return (
    <main class="page" id="main" data-page="not-found">
      <h1>{t('notFound.title')}</h1>
      <p>{t('notFound.body')}</p>
      <Footer />
    </main>
  );
}
